module.exports = __webpack_public_path__ + "static/media/gt.4eea9e03.svg";